const terminalStatuses = new Set(['completed', 'completed_with_errors', 'failed']);

async function responseJson(response) {
  let data = {};
  try {
    data = await response.json();
  } catch (_error) {
    // The fallback below is intentionally safe for proxy and HTML errors.
  }
  if (!response.ok) {
    throw new Error(data.error || data.detail || data.message || `Request failed (${response.status})`);
  }
  return data;
}

export async function enqueueCalendarRefresh({ apiBase, token, payload, fetchImpl = fetch }) {
  const response = await fetchImpl(`${apiBase}/studentplayground/refresh/`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return responseJson(response);
}

export async function pollCalendarRefresh({
  statusUrl,
  token,
  fetchImpl = fetch,
  wait = () => new Promise((resolve) => setTimeout(resolve, 2500)),
  onUpdate = () => {},
  signal,
}) {
  while (!signal?.aborted) {
    const response = await fetchImpl(statusUrl, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
      signal,
    });
    const job = await responseJson(response);
    onUpdate(job);
    if (terminalStatuses.has(job.status)) return job;
    await wait();
  }
  throw new DOMException('Calendar refresh polling was cancelled', 'AbortError');
}

